import React, { type ComponentProps } from 'react'

import { usePlatformFeatureFlags } from '@components'
import { ProductBoxStatic, useProductBox } from '@fourthwall/module-product'
import { useWebViewBridge } from '@fourthwall/webview-bridge'
import { useOnceInView, useTagManager } from '@hooks'

import { useCurrentShop } from '../../../../hooks/useCurrentShop'

type HomeProductsProductBoxProps = {
  product: ComponentProps<typeof ProductBoxStatic>['product']
  activeCategory: 'recommendations' | 'favorites'
  href: string
}

export const SliderProductBox = ({
  product,
  href,
  activeCategory,
}: HomeProductsProductBoxProps) => {
  const { isWebView } = useWebViewBridge()
  const tagManager = useTagManager()
  const { hasFeatureFlag } = usePlatformFeatureFlags()
  const { currentShop } = useCurrentShop()

  const ref = useOnceInView(() =>
    tagManager.trigger('recommendation_view', {
      recommendation_type: 'create_new_product',
      flow: 'product',
      product_id: product.id,
      product_name: product.name,
      shop_id: currentShop?.id || '',
      experiment_variant: hasFeatureFlag('dashboard:recommended_products_experiment')
        ? 'ACTIVE'
        : 'NONE',
      active_category: activeCategory,
    }),
  )
  const productBox = useProductBox({ product })

  return (
    <div ref={ref}>
      <ProductBoxStatic
        size="compact"
        product={product}
        href={href}
        activeProduct={productBox.activeProduct}
        isWebView={isWebView}
      />
    </div>
  )
}
